import moment from 'moment';
import { Country } from '../components';

type Banner = {
  id: string;
  label: string;
  image: string;
  link: string;
  startDate?: moment.Moment;
  endDate?: moment.Moment;
}[];
const getReferalLink = (target: string, country: string) => {
  if (country === Country.KR) {
    const params = new URLSearchParams({
      utm_source: target,
      utm_medium: 'referral',
      utm_campaign: `${target}-banner`,
      utm_content: '도도 포인트가 궁금하시다면?',
      utm_term: 'store name', // FIXME
    });

    return `https://www.yanoljafnbsolution.com/ad-contact/?${params.toString()}`;
  } else {
    return `https://forms.gle/L8bmCW3NaEo675t76`;
  }
};

export type BannerTarget = 'profile' | 'edit-my-info';
export const findBanner = (target: BannerTarget, contry: string = Country.KR, isSmallBanner = true): Banner => {
  if (contry === Country.KR) {
    return findKRBanner(target, isSmallBanner);
  } else {
    return findJPBanner(target, isSmallBanner);
  }
};

export const findJPBanner = (target: string, isSmallBanner = true): Banner => {
  return [
    {
      id: 'dodojp',
      label: '도도 포인트가 궁금하시다면?',
      image: require(`../images/banner_jp_${isSmallBanner ? 'sm' : 'lg'}.png`),
      link: getReferalLink(target, Country.JP),
    },
  ];
};

export const findKRBanner = (target: string, isSmallBanner = true): Banner => {
  const banners = [
    {
      id: 'songchugamagol',
      label: '송추가마골',
      image: require('../images/banner_20241125_songchugamagol.png'),
      link: 'https://bit.ly/3CGheyr',
      startDate: moment('2024-11-25 15:00:00', 'YYYY-MM-DD HH:mm:ss'),
      endDate: moment('2024-12-31 23:59:59', 'YYYY-MM-DD HH:mm:ss'),
    },
    {
      id: 'bulmakyeolsam',
      label: '불막열삼',
      image: require('../images/banner_20241121_bulmakyeolsam.png'),
      link: 'https://buly.kr/C08jzhX',
      startDate: moment('2024-11-21 10:00:00', 'YYYY-MM-DD HH:mm:ss'),
      endDate: moment('2024-12-31 23:59:59', 'YYYY-MM-DD HH:mm:ss'),
    },
    {
      id: 'yaorder',
      label: '야오더',
      image: require('../images/banner_20241105_yaorder.png'),
      link: 'https://www.yanoljafnbsolution.com/yaorder?utm_source=dodo_mobile&utm_medium=banner&utm_campaign=ap_ad&utm_content=241104&',
      startDate: moment('2024-11-05 15:00:00', 'YYYY-MM-DD HH:mm:ss'),
      endDate: moment('2025-12-31 23:59:59', 'YYYY-MM-DD HH:mm:ss'),
    },
  ];

  const defaultBanner = {
    id: 'dodo',
    label: '도도 포인트가 궁금하시다면?',
    image: require(`../images/banner_${isSmallBanner ? 'sm' : 'lg'}.png`),
    link: getReferalLink(target, Country.KR),
  };

  const currentDate = moment();
  const activeBanners = banners.filter((banner) => currentDate.isBetween(banner.startDate, banner.endDate));

  return [...activeBanners, defaultBanner];
};
